import * as React from 'react';
import { useFormik, FormikValues } from 'formik';
import { Constants, Validators } from 'core';
import { useSelector } from 'react-redux';
import Input from '../../organisms/input';
import Button from '../../molecules/button';
import { UserInfoSelectors, ResetPasswordSelectors, AuthSelectors } from '../../../common/config/store';
import { useIntl } from '../../../common/config/i18n';
import FormError from '../../molecules/form-error';
import { StyledFormWrapper as WrapperForm } from '../../../common/styling/mixins';

interface FormValues {
  email?: string;
}
interface OtherProps {
  title?: string;
  onSubmit: (values: FormikValues) => void;
}

const Form = (props: FormValues & OtherProps) => {
  const { t } = useIntl();
  const [formFocused, setFormFocused] = React.useState(false);
  const isLoginExpired = useSelector(AuthSelectors.isLoginExpiredSelector);
  const defaultUserNameIfLogin = useSelector(UserInfoSelectors.userNameSelector);
  const defaultUserNameIfLoginExpired = useSelector(AuthSelectors.userNameSelector);
  const status = useSelector(ResetPasswordSelectors.statusSelector);
  const error = useSelector(ResetPasswordSelectors.errorSelector);
  const errorMessage = useSelector(ResetPasswordSelectors.errorMessageSelector);

  const formik = useFormik({
    initialValues: {
      userName: isLoginExpired ? defaultUserNameIfLoginExpired : defaultUserNameIfLogin,
      password: '',
      newPassword: '',
      confirmNewPassword: '',
    },
    validate: (values) => Validators.updatePassword(values),
    onSubmit: (values) => {
      setFormFocused(false);
      props.onSubmit(values);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <WrapperForm>
        <input type="hidden" name="userName" onChange={formik.handleChange} value={formik.values.userName} />
        <Input
          width="270px"
          upLabel={isLoginExpired ? t('form', 'FORM_EXPIRED_CURRENT_PASSWORD') : t('form', 'FORM_UPDATE_TEMP_PASSWORD')}
          type="password"
          name="password"
          onChange={formik.handleChange}
          value={formik.values.password}
          onFocus={() => setFormFocused(true)}
        />
        <FormError formik={formik} fieldName="password" />
        <Input
          width="270px"
          upLabel={t('form', 'FORM_UPDATE_NEW_PASSWORD')}
          type="password"
          name="newPassword"
          onChange={formik.handleChange}
          value={formik.values.newPassword}
          onFocus={() => setFormFocused(true)}
        />
        <FormError formik={formik} fieldName="newPassword" />
        <Input
          width="270px"
          upLabel={t('form', 'FORM_UPDATE_CONFIRM_PASSWORD')}
          type="password"
          name="confirmNewPassword"
          onChange={formik.handleChange}
          value={formik.values.confirmNewPassword}
          onFocus={() => setFormFocused(true)}
        />
        <FormError formik={formik} fieldName="confirmNewPassword" />
      </WrapperForm>
      {errorMessage && !formFocused && status !== 'loading' ? (
        errorMessage === Constants.UPDATE_PASSWORD_WRONG_TEMPORARY_PWD ? (
          <FormError message={t('form', 'FORM_WRONG_TEMPORARY_PWD')} />
        ) : (
          <FormError message={errorMessage} />
        )
      ) : (
        error && !formFocused && status !== 'loading' && <FormError message={t('form', 'FORM_UNKNOWN_ERROR')} />
      )}

      <Button
        height="50px"
        width="100%"
        borderRadius="20px"
        disabled={!formik.isValid && Object.keys(formik.touched).length !== 0}
        loading={status === 'loading'}
        htmlType="submit"
      >
        {t('Buttons', 'RESET_BUTTON')}
      </Button>
    </form>
  );
};
export default Form;
